import { includes } from 'lodash';

export const isTeacher = auth => auth.role === 'teacher'
export const isPartnerAdmin = auth => auth.role === 'partner_admin'
export const isPartnerAdminDashboard = auth => auth.role === 'partner_admin_dashboard' || auth.role === 'coach' || isAdminDashboard(auth)
export const isAdmin = auth => !isTeacher(auth)
export const isAdminDashboard = auth => auth.role === 'admin' || auth.role === 'superadmin'
export const isTeachersEnabled = auth => includes(auth.options, 'teacherEnabledDashboard') || isAdminDashboard(auth)
export const isEditable = auth => includes(auth.options, 'editable') || isAdminDashboard(auth)
export const isChatEnabled = auth => (includes(auth.options, 'accountPlayers') && includes(auth.options, 'accountPlayer') && includes(auth.options, 'chatEnabled'));
export const isWithPermissions = auth => auth.role === 'partner_admin_dashboard' || auth.role === 'coach'

export const getNotesQuestionnaire = auth => `result.questionnaires.${isTeacher(auth) ? 'teacher' : 'parent'}`

export const isASQEnabled = auth => includes(auth.options, 'asqEnabled') || isAdminDashboard(auth)

export const TEACHER_DASHBOARD_SCOPE = ['superadmin', 'admin', 'coach', 'partner_admin_dashboard', 'partner_admin', 'teacher'];
export const PARTNER_DASHBOARD_SCOPE = ['superadmin', 'admin', 'coach', 'partner_admin_dashboard'];
export const TRANSLATOR_DASHBOARD_SCOPE = ['superadmin', 'admin', 'translator'];
export const ALL_DASHBOARD_SCOPE = TEACHER_DASHBOARD_SCOPE + ['translator'];
